import Utils from "../utils/utils"
const utilsHelper = new Utils()

export default class SubscriptionTable {
    constructor(config){
        this.config = config
    }

    display(){
        let that = this
        window.addEventListener('message', function(e){
            // console.log('this.config',this.config)
            if (e.origin.indexOf(that.config.DOMAIN) === -1){
                return
            }

            console.log('event',e)
            let data = e.data
            if (data.height) {
                console.log('height', data.height)
                let iframe_src = `${e.origin}/subscription/plan` 
                let iframes = Array.from(document.querySelectorAll(`iframe[src="${iframe_src}"]`))
                console.log('iframes', iframes)
                iframes.forEach(function(iframe){
                    console.log(iframe.style)
                    iframe.style.height = `${data.height}`
                })
            }

        })
    }
}